import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class RefundService extends BaseService {

  constructor(public http: HttpClient, authService: AuthService) {
    super(authService);
  }

  //get refund reason code
  public refundReason() {
    return this.http.get(this.baseUrl + '/RefundReason/list',
      this.headerWithToken()).pipe(map(res => res));
  }

  //raise refund request 
  public raiseRefund(refundData: any) {
    return this.http.post(this.baseUrl + '/RefundPayment', refundData,
      this.headerWithToken()).pipe(map(res => res));
  }

  // get all refund According to custId
  public getRefund(refundrequestData: any) {
    return this.http.post(this.baseUrl + '/RefundPayment/RefundData', refundrequestData,
      this.headerWithToken()).pipe(map(res => res));
  }

  //cancel Refund
  public cancelRefund(refundRequestId: any) {
    return this.http.get(this.baseUrl + '/RefundPayment/CancelRefundPayment/' + refundRequestId,
      this.headerWithToken()).pipe(map(res => res));
  }

  //particular refundDetails by id
  public getRefundDetailsById(refundRequestId: any) {
    return this.http.get(this.baseUrl + '/RefundPayment/RefundRequestDataByRefundRequestId/' + refundRequestId,
      this.headerWithToken()).pipe(map(res => res));
  }

  //refund 
  private dataSubject = new BehaviorSubject<any>(null);
  public refundAmt$ = this.dataSubject.asObservable();

  sendRefundAmount(refundAmt: any) {
    this.dataSubject.next(refundAmt);
  }
}
